<app-form-field-lotto-line
  [data]="data"
  [editMode]="editMode"
  [fieldConfig]="fieldConfig"
  [tableMode]="true"></app-form-field-lotto-line>
